import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
export const formatCurrency = (value, currency) => {
  const num = Number(value) || 0;
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return `${num.toFixed(2)}`;
  }
};

export const formatMonthYear = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  return d.toLocaleString(undefined, { month: "short", year: "numeric" });
};
